// posts コレクションのドキュメント形状。post_student:true(学生自身の投稿)と
// post_student:false(サロン投稿)が同じコレクションを共有しているため、
// ここで定義するのはサロン側(5.photo配下)が読み書きするフィールドのみ。
// 未知のフィールドを消してしまわないよう、書き込みは常に対象フィールドのみをupdateDocする。

export type PostStatus = '公開中' | '非公開' | 'アーカイブ';

export type PostDoc = {
  companyId: string;
  post_count: number;
  post_liker: string[];
  post_likes: string[];
  post_instagram: string;
  post_tiktok: string;
  post_user_image_1080: string;
  post_user_image_500: string;
  post_name: string;
  post_image_1080: string;
  post_image_500: string;
  post_image_name: string;
  post_image_path: string;
  post_tags: string[];
  post_uid: string;
  post_time: any;
  post_views: string[];
  post_student: boolean;
  companyLikes?: string[];
  // --- 新規追加フィールド(いずれもoptional。既存ドキュメントには存在しない) ---
  post_title?: string;
  post_description?: string;
  post_staff_id?: string;
  post_status?: PostStatus;
  post_updated_at?: any;
};

// クライアント側で使う正規化済みの1行分データ。以降のコンポーネントは
// このPhotoRowのみを扱い、生のFirestoreデータには触れない。
export type PhotoRow = {
  id: string;
  companyId: string;
  post_tags: string[];
  post_title: string;
  post_description: string;
  post_staff_id: string;
  post_status: PostStatus;
  post_time: Date;
  post_updated_at: Date | null;
  post_views: string[];
  post_likes: string[];
  post_liker: string[];
  post_uid: string;
  post_student: boolean;
};

function toDateSafe(value: any): Date {
  if (!value) return new Date();
  if (typeof value?.toDate === 'function') return value.toDate();
  return new Date(value);
}

export function toPhotoRow(id: string, data: any): PhotoRow {
  return {
    id,
    companyId: data.companyId ?? '',
    post_tags: Array.isArray(data.post_tags) ? data.post_tags : [],
    post_title: data.post_title ?? '',
    post_description: data.post_description ?? '',
    post_staff_id: data.post_staff_id ?? '',
    post_status: (data.post_status as PostStatus) ?? '公開中',
    post_time: toDateSafe(data.post_time),
    post_updated_at: data.post_updated_at ? toDateSafe(data.post_updated_at) : null,
    post_views: Array.isArray(data.post_views) ? data.post_views : [],
    post_likes: Array.isArray(data.post_likes) ? data.post_likes : [],
    post_liker: Array.isArray(data.post_liker) ? data.post_liker : [],
    post_uid: data.post_uid ?? '',
    post_student: data.post_student ?? false,
  };
}

export type StaffOption = {
  id: string;     // staffProfiles の Firestore doc id(post_staff_id はこれを保存する)
  docId: string;  // Storage画像パス専用の内部id(staffProfiles/{docId})
  name: string;
  position: string;
};
